export const DAO_CODE = 'EXPENSE' + '_ATTACHMENT' + '_DAO';
